import { gql } from 'graphql-request'

export const SINCRONIZAR_DEALERS = gql`
  mutation SincronizarDealersMutation {
    sincronizarDealers
  }
`
